import React, { useState, useEffect } from 'react';
import { useEnroll } from '../context/EnrollContext';
import styles from './Navbar.module.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { open } = useEnroll();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    { label: 'Curriculum', href: '#curriculum' },
    { label: 'Outcomes',   href: '#outcomes' },
    { label: 'Mentor',     href: '#mentor' },
    { label: 'Reviews',    href: '#reviews' },
    { label: 'FAQ',        href: '#faq' },
  ];

  return (
    <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ''}`}>
      <div className={styles.container}>
        <a href="#top" className={styles.logo} aria-label="Digimint – Home">
          digi<span>mint</span>
        </a>

        {/* Desktop links */}
        <ul className={styles.links}>
          {navLinks.map(l => (
            <li key={l.href}>
              <a href={l.href} className={styles.link}>{l.label}</a>
            </li>
          ))}
        </ul>

        <a href="#" className={styles.cta} onClick={e => { e.preventDefault(); open(); }}>
          Enroll Now
        </a>

        {/* Mobile hamburger */}
        <button
          className={`${styles.hamburger} ${menuOpen ? styles.open : ''}`}
          onClick={() => setMenuOpen(p => !p)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile menu */}
      <div className={`${styles.mobileMenu} ${menuOpen ? styles.mobileOpen : ''}`}>
        {navLinks.map(l => (
          <a
            key={l.href}
            href={l.href}
            className={styles.mobileLink}
            onClick={() => setMenuOpen(false)}
          >
            {l.label}
          </a>
        ))}
        <a href="#" className={styles.mobileCta} onClick={e => { e.preventDefault(); setMenuOpen(false); open(); }}>
          Enroll Now — Free Counselling
        </a>
      </div>
    </nav>
  );
}
